/*
 * @Author: huangzq
 * @Date: 2019-12-31 15:13:56
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-09-27 01:16:56
 * @Desc: 基础设置
*/
<template>
  <div class="basic-set">
    <!-- 基本信息：封面、标题、描述 -->
    <div class="basic-info">
      <!-- 左侧：封面 -->
      <div
        class="left-cover"
      >
        <mk-upload-oss-biz
          :token-api="ossTokenApi"
          :bucket="$env.VUE_APP_ALI_OSS_BUCKET"
          :disabled="imagesLoading"
          upload-type="image"
          @on-upload="imageUpload"
        >
          <mk-image
            v-loading="imagesLoading"
            :src="materialData.cover"
            fit="cover"
          />
        </mk-upload-oss-biz>
      </div>
      <!-- 右侧：标题、描述 -->
      <div class="right-info">
        <mk-form
          :model="materialData"
          :label-width="isShowCofInput?'70px':'40px'"
        >
          <mk-form-item label="标题">
            <mk-input
              v-model="materialData.title"
              height="40"
              maxlength="20"
              placeholder="请输入标题"
              show-word-limit
            />
          </mk-form-item>
          <mk-form-item label="描述">
            <mk-input
              v-model="materialData.desc"
              type="textarea"
              :height="isShowCofInput?'70':'106'"
              resize="none"
              maxlength="50"
              placeholder="请输入描述"
              show-word-limit
            />
          </mk-form-item>
          <mk-form-item
            v-if="isShowCofInput"
            label="发圈文案"
          >
            <mk-input
              v-model="materialData.copyWriting"
              type="textarea"
              height="70"
              resize="none"
              maxlength="50"
              placeholder="请输入发朋友圈的文案"
              show-word-limit
            />
          </mk-form-item>
        </mk-form>
      </div>
    </div>

    <mk-form
      :model="materialData"
      label-position="top"
    >
      <!-- 排列方式 -->
      <div class="array-mode">
        <mk-form-item label="排列方式">
          <div class="bottom-border">
            <mk-radio-group
              v-model="materialData.direction"
              @change="updateIframe"
            >
              <mk-radio
                v-for="item in directionList"
                :key="item.code"
                :label="item.code"
              >
                {{ item.name }}
              </mk-radio>
            </mk-radio-group>
          </div>
          <div>
            <mk-checkbox
              v-model="materialData.loop"
              label="循环设置"
              @change="updateIframe"
            />
            <mk-checkbox
              v-model="materialData.autoPlay.open"
              label="自动翻页"
              @change="updateIframe"
            />
            <template v-if="materialData.autoPlay.open">
              <mk-input
                v-model="materialData.autoPlay.delay"
                width="50"
                height="24"
                maxlength="2"
                @change="updateIframe"
              />
              秒
            </template>
          </div>
        </mk-form-item>
      </div>

      <!-- 背景音乐 -->
      <div class="bg-music-wrapper">
        <mk-form-item label="背景音乐">
          <div
            class="bg-music"
          >
            <div
              v-show="materialData.music.href"
              class="music-show"
            >
              <!-- 播放、暂停 -->
              <div
                class="play"
                @click="playMusic"
              >
                <mk-iconfont
                  v-if="isPlayMusic"
                  icon-class="zanting"
                />
                <mk-iconfont
                  v-else
                  icon-class="bofang"
                />
              </div>
              <div class="line" />
              <!-- 音乐名称 -->
              <div class="music-name ellipsis">
                {{ materialData.music.name }}
              </div>
              <!-- 删除 -->
              <div
                class="delete"
                @click="deleteMusic"
              >
                <mk-iconfont
                  icon-class="shanchutp"
                />
              </div>
              <!-- audio -->
              <audio
                ref="audio"
                :key="materialData.music.href"
                class="music-audio"
                :src="materialData.music.href"
              />
            </div>
            <mk-upload-oss-biz
              :token-api="ossTokenApi"
              :bucket="$env.VUE_APP_ALI_OSS_BUCKET"
              :limit-size="20"
              accept=".mp3"
              no-accept-msg="MP3文件不能超过20M"
              :disabled="musicLoading"
              @on-upload="musicUpload"
            >
              <!-- MP3文件不能超过8M -->
              <mk-button-biz
                :loading="musicLoading"
                type="primary"
                width="90px"
                height="40px"
              >
                {{ materialData.music.href?'更换':'选择' }}音乐
              </mk-button-biz>
            </mk-upload-oss-biz>
          </div>
        </mk-form-item>
      </div>

      <!-- 员工二维码 -->
      <sale-qrcode-set
        v-model="materialData.isShowQRCode"
        @change="updateIframe"
      >
        <div slot="tips">
          <p>
            开启后客户可通过二维码联系到跟进销售
          </p>
        </div>
      </sale-qrcode-set>
    </mk-form>
  </div>
</template>

<script>
import { EDITORAPIS } from '@api'
import SaleQrcodeSet from '@/views/marketing-content/marketing-data/components/common/sale-qrcode-set'

export default {
  name: 'BasicSet',
  components: { SaleQrcodeSet },
  props: {
    materialData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      // 获取阿里云oss上传token的接口，使用的是编辑器项目里面的接口
      ossTokenApi: {
        api: EDITORAPIS.OssApi.v1OssStsTokenGet,
        params: { ttl: 10000 }
      },
      // 图片是否正在上传
      imagesLoading: false,
      // 是否显示发圈文案输入框
      isShowCofInput: false,
      // 排列方式列表数据
      directionList: [
        {
          code: 'vertical',
          name: '上下翻页'
        },
        {
          code: 'horizontal',
          name: '左右翻页'
        }
      ],
      // 音乐是否正在上传
      musicLoading: false,
      // 是否正在播放音乐
      isPlayMusic: false
    }
  },

  created () {
    this.isShowCofInput = this.util.storage.getItem('iscof')
  },
  methods: {
    // 图片上传事件
    imageUpload (res) {
      if (res.type === 'fail') {
        this.$message.error('上传失败')
        this.imagesLoading = false
      } else if (res.type === 'success') {
        this.imagesLoading = false
        this.materialData.cover = res.result.url
      } else if (res.type === 'before') {
        this.imagesLoading = true
      } else if (res.type === 'progress') {
        this.imagesLoading = true
      }
    },
    // 音乐上传事件
    musicUpload (res) {
      if (res.type === 'fail') {
        this.$message.error('上传失败')
        this.musicLoading = false
      } else if (res.type === 'success') {
        this.musicLoading = false

        this.materialData.music = {
          name: res.file.name,
          href: res.result.url
        }
        this.isPlayMusic = false
        this.updateIframe()
      } else if (res.type === 'before') {
        this.musicLoading = true
      } else if (res.type === 'progress') {
        this.musicLoading = true
      }
    },

    // 播放音乐事件
    playMusic () {
      this.isPlayMusic = !this.isPlayMusic

      if (this.isPlayMusic) {
        this.$refs.audio.play()
        // 触发iframe子窗口事件
        this.$emit('on-iframe-event', 'music-pause')
      } else {
        this.$refs.audio.pause()
      }
    },

    // 删除音乐
    deleteMusic () {
      this.materialData.music.href = ''
      this.materialData.music.name = ''
      this.updateIframe()
    },

    // 触发 iframe的更新
    updateIframe () {
      this.materialData.contactOpt = Number(this.materialData.isShowQRCode)
      this.$emit('on-iframe-data')
    }

  }
}
</script>

<style lang='scss' scoped>
.basic-set {
  // 基本信息：封面、标题、描述
  .basic-info {
    display: flex;

    .left-cover {
      .mk-upload-oss {
        .mk-image {
          width: 160px;
          height: 160px;
        }
      }
    }

    .right-info {
      flex: 1px;
      margin-left: 20px;

      & /deep/ .el-form {
        .el-form-item {
          margin-bottom: 14px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  & /deep/ .el-form--label-top {
    margin-top: 24px;

    .el-form-item {
      margin-bottom: 20px;

      .el-form-item__label {
        padding-bottom: 0;
      }
    }

    .array-mode {
      .el-checkbox__label,
      .el-radio__label {
        display: inline-block;
        width: 70px;
        box-sizing: border-box;
      }

      .bottom-border {
        border-bottom: 1px solid #e8e8e8;
      }
    }

    .bg-music-wrapper {
      .bg-music {
        display: flex;

        .music-show {
          display: flex;
          align-items: center;
          width: 330px;
          height: 40px;
          margin-right: 40px;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          box-sizing: border-box;
          overflow: hidden;

          .play {
            display: flex;
            align-items: center;
            color: #d8d8d8;

            .iconfont {
              padding: 0 10px;
              font-size: 24px;
              color: #d8d8d8;

              @extend .cursor;
            }

            .icon-mk-bofang {
              color: #009cff;
            }
          }

          .line {
            width: 1px;
            height: 24px;
            background-color: #f5f5f5;
          }

          .music-name {
            flex: 1;
            margin: 0 15px;
            line-height: normal;
            font-size: 13px;
            color: #595959;
          }

          .delete {
            width: 40px;
            text-align: center;
            background-color: #f5f5f5;

            @extend .cursor;

            .iconfont {
              color: #d8d8d8;
            }
          }

          .music-audio {
            display: none;
          }
        }
      }
    }
  }
}
</style>
